export const handleMenuButton = (menu, setter) => {
  setter((prev) => ({
    ...prev,
    [menu]: !prev[menu],
  }))
}
